
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const DeviceTokenType = {
  EXPO: 'EXPO',
  FCM: 'FCM',
  APNS: 'APNS'
} as const

export type DeviceTokenType = (typeof DeviceTokenType)[keyof typeof DeviceTokenType]


export const DevicePlatform = {
  ANDROID: 'ANDROID',
  IOS: 'IOS'
} as const

export type DevicePlatform = (typeof DevicePlatform)[keyof typeof DevicePlatform]


export const Status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED'
} as const

export type Status = (typeof Status)[keyof typeof Status]


export const NudgeChannel = {
  EMAIL: 'EMAIL',
  PUSH: 'PUSH',
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP',
  IVR: 'IVR'
} as const

export type NudgeChannel = (typeof NudgeChannel)[keyof typeof NudgeChannel]


export const PaymentMethodType = {
  CARD: 'CARD',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  THIRD_PARTY: 'THIRD_PARTY'
} as const

export type PaymentMethodType = (typeof PaymentMethodType)[keyof typeof PaymentMethodType]


export const BankAccountType = {
  CHECKING: 'CHECKING',
  SAVINGS: 'SAVINGS'
} as const

export type BankAccountType = (typeof BankAccountType)[keyof typeof BankAccountType]


export const PaymentMethodDisabledReason = {
  LOST: 'LOST',
  STOLEN: 'STOLEN',
  EXPIRED: 'EXPIRED',
  FRAUD: 'FRAUD',
  OTHER: 'OTHER',
  RE_AUTH: 'RE_AUTH'
} as const

export type PaymentMethodDisabledReason = (typeof PaymentMethodDisabledReason)[keyof typeof PaymentMethodDisabledReason]


export const Currency = {
  USD: 'USD',
  CAD: 'CAD',
  EUR: 'EUR',
  GBP: 'GBP',
  JPY: 'JPY',
  AUD: 'AUD',
  CNY: 'CNY'
} as const

export type Currency = (typeof Currency)[keyof typeof Currency]


export const AutoPayFrequency = {
  ON_DUE_DATE: 'ON_DUE_DATE',
  ON_RECEIVED_DATE: 'ON_RECEIVED_DATE',
  THREE_DAYS_BEFORE_DUE_DATE: 'THREE_DAYS_BEFORE_DUE_DATE',
  CUSTOM_DATE: 'CUSTOM_DATE'
} as const

export type AutoPayFrequency = (typeof AutoPayFrequency)[keyof typeof AutoPayFrequency]


export const MaxPaymentAmountPreference = {
  FULL_INVOICE_AMOUNT: 'FULL_INVOICE_AMOUNT',
  FIXED_AMOUNT: 'FIXED_AMOUNT'
} as const

export type MaxPaymentAmountPreference = (typeof MaxPaymentAmountPreference)[keyof typeof MaxPaymentAmountPreference]


export const CustomAutoPayFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
} as const

export type CustomAutoPayFrequency = (typeof CustomAutoPayFrequency)[keyof typeof CustomAutoPayFrequency]


export const PluginStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED'
} as const

export type PluginStatus = (typeof PluginStatus)[keyof typeof PluginStatus]


export const UtilityType = {
  Electricity: 'Electricity',
  Water: 'Water',
  Gas: 'Gas',
  Data: 'Data',
  Other: 'Other'
} as const

export type UtilityType = (typeof UtilityType)[keyof typeof UtilityType]


export const UtilityAccountStatus = {
  CONNECTED: 'CONNECTED',
  CONNECT_PENDING: 'CONNECT_PENDING',
  DISCONNECT_PENDING: 'DISCONNECT_PENDING',
  DISCONNECTED: 'DISCONNECTED',
  INACTIVE: 'INACTIVE',
  ERROR: 'ERROR'
} as const

export type UtilityAccountStatus = (typeof UtilityAccountStatus)[keyof typeof UtilityAccountStatus]


export const MeterStatus = {
  UNINSTALLED: 'UNINSTALLED',
  PENDING: 'PENDING',
  DISCONNECTED: 'DISCONNECTED',
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  ERROR: 'ERROR'
} as const

export type MeterStatus = (typeof MeterStatus)[keyof typeof MeterStatus]


export const SyncStatus = {
  PENDING: 'PENDING',
  SYNCING: 'SYNCING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
} as const

export type SyncStatus = (typeof SyncStatus)[keyof typeof SyncStatus]


export const ServiceAccountType = {
  UTILITY: 'UTILITY',
  INSURANCE: 'INSURANCE',
  FEDERAL: 'FEDERAL',
  MUNICIPALITY: 'MUNICIPALITY',
  OTHER: 'OTHER'
} as const

export type ServiceAccountType = (typeof ServiceAccountType)[keyof typeof ServiceAccountType]


export const TenantStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
  PENDING: 'PENDING',
  INSIDERS: 'INSIDERS'
} as const

export type TenantStatus = (typeof TenantStatus)[keyof typeof TenantStatus]


export const Theme = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  SYSTEM: 'SYSTEM',
  TILLI: 'TILLI'
} as const

export type Theme = (typeof Theme)[keyof typeof Theme]


export const UserOnboardingStep = {
  PROFILE: 'PROFILE',
  ACCOUNTS: 'ACCOUNTS',
  PREFERENCES: 'PREFERENCES',
  NOTIFICATIONS: 'NOTIFICATIONS',
  COMPLETE: 'COMPLETE'
} as const

export type UserOnboardingStep = (typeof UserOnboardingStep)[keyof typeof UserOnboardingStep]


export const ContactType = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP'
} as const

export type ContactType = (typeof ContactType)[keyof typeof ContactType]
